<template>
  <v-tabs fixed-tabs v-model="tab" centered >
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab :href="`#list`">
      {{ $t("components.editicons.gallery") }}
    </v-tab>

    <v-tab-item :value="'list'">
      <icon-list
        ref="iconList"
        :selectedIcon.sync="selectedIconInternal"
      ></icon-list>
    </v-tab-item>

    <v-tab :href="`#upload`">
      {{ $t("globals.upload") }}
    </v-tab>

    <v-tab-item :value="'upload'">
      <icon-uploader :icon.sync="selectedIconInternal"></icon-uploader>
    </v-tab-item>
  </v-tabs>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import IconList from "./IconList";
import IconUploader from "./IconUploader";
export default {
  components: {
    IconList,
    IconUploader,
  },
  props: {
    selectedIcon: Object,
  },
  data: () => ({
    tab: "list",
    selectedIconInternal: undefined,
  }),
  watch: {
    selectedIconInternal: {
      immediate: true,
      handler() {
        this.tab = "list";
        if (this.$refs.iconList) this.$refs.iconList.loadIcons();
        this.$emit("update:selectedIcon", this.selectedIconInternal);
      },
    },
  },
  computed: {
    
  },
  methods: {
    ...mapActions("downloadCenter", ["saveIcon"]),
  },
};
</script>
